module.exports = __webpack_public_path__ + "static/media/CustomHandlesCreator.ff2014d7.md";